<template>
  <div class="public-content complain-list">
    <div class="breadcrumb">投诉列表</div>
    <div class="right-main">
      <!-- 查询订单 -->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-input v-model="formInline.salesmanName" placeholder="请输入业务" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-input v-model="formInline.storeCode" placeholder="请输入平台号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号:">
              <el-input v-model="formInline.phone" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="状态:">
              <el-select v-model="formInline.handleStatus" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option label="待处理" value="PENDING"></el-option>
                <el-option label="已处理" value="HANDLE"></el-option>
                <!-- <el-option label="已拒绝" value="REFUSE"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="投诉日期:" class="el-date-width">
              <el-date-picker clearable v-model="value2" type="daterange" align="left" unlink-panels range-separator="至" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期"
                :picker-options="pickerOptions" format="yyyy - MM - dd " value-format="yyyy-MM-dd" @change="changeDate">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button type="primary" @click="typeDialog = true, getComplaintsTypeList()" round>投诉类型管理</el-button>
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, onSubmit()" round>查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" :row-class-name="rowClassName" border style="width: 100%">
          <el-table-column prop="storeCode" label="平台号" min-width="10"></el-table-column>
          <el-table-column prop="storeName" label="平台名称" min-width="10"></el-table-column>
          <el-table-column prop="phone" label="手机号" min-width="10"></el-table-column>
          <el-table-column prop="salesmanName" label="业务" min-width="10"></el-table-column>
          <el-table-column prop="typeName" label="投诉类型" min-width="10"></el-table-column>
          <el-table-column prop="content" label="投诉内容" min-width="10"></el-table-column>
          <el-table-column prop="results" label="投诉结果" min-width="10"></el-table-column>
          <el-table-column prop="createdTime" label="投诉日期" min-width="10"></el-table-column>
          <el-table-column label="状态" min-width="10px">
            <template v-slot="scope">
              <span :class="{ 'color-blue': scope.row.handleStatus === '待处理' }" v-if="$hasPermission('crm:admin:complaints:handle')" @click="getOrderStatus(scope.row)">{{ scope.row.handleStatus
              }}</span>
              <span v-else>{{ scope.row.handleStatus }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
    </div>
    <el-dialog :close-on-click-modal="false" title="投诉类型管理" :visible.sync="typeDialog" width="500px">
      <div>
        <span>投诉类型：</span>
        <el-input v-model="name" placeholder="请输入内容" style="width:180px;margin:0 10px 0 5px;" clearable></el-input>
        <el-button type="primary" @click="addType(name)" round>添加</el-button>
      </div>
      <el-table :data="typeList" border="" style="width: 100%;margin:10px 0 0 0;">
        <el-table-column prop="name" label="投诉类型"></el-table-column>
        <el-table-column label="操作" width="150">
          <tamplate slot-scope="scope">
            <span class="color-blue" @click="deleteType(scope)">删除</span>
          </tamplate>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="typeDialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 审核 -->
    <el-dialog :close-on-click-modal="false" title="投诉详情" :visible.sync="checkDialog" width="500px">
      <el-form ref="form" :model="checkFrom" label-width="130px">
        <el-form-item label="平台号："> {{ checkFrom.storeCode }} </el-form-item>
        <el-form-item label="业务："> {{ checkFrom.salesmanName }} </el-form-item>
        <el-form-item label="投诉内容：">
          <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="checkFrom.content" disabled clearable></el-input>
        </el-form-item>
        <el-form-item label="处理结果：">
          <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="checkFrom.results" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="check">处理</el-button>
      </span>
    </el-dialog>
    <!-- <CombinedDialog ref="dialogRef" @asd="asd" @changeComplain="setComplain"></CombinedDialog> -->
  </div>
</template>
 <script>
import VPagination from '@/components/Pagination/index.vue'
// import CombinedDialog from '@/components/Dialog/CombinedDialog/index.vue'
import { complaintsGetComplaintsList, getComplaintsTypeList, deleteComplaintsType, addComplaintsType, complaintGetById, complaintsHandleComplaints } from '@/api/crm'
export default {
  name: 'complain-list',
  components: {
    VPagination
    // CombinedDialog
  },
  data () {
    return {
      checkFrom: {},
      checkDialog: false,
      name: '',
      typeList: [],
      typeDialog: false,
      formInline: {
        salesmanName: '',
        storeCode: '',
        phone: '',
        createTimeBegin: '',
        createTimeEnd: '',
        handleStatus: ''
      },
      tableData: [],
      value2: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      }
    }
  },
  created () {
    if (this.$route.query.handleStatus === 'PENDING') {
      this.formInline.handleStatus = 'PENDING'
    }
    this.getComplain(this.queryInfo)
  },
  methods: {
    check () {
      if (!this.checkFrom.results) {
        this.$message.error('未填写处理结果')
        return
      }
      complaintsHandleComplaints({ handleStatus: 'HANDLE', id: this.checkFrom.id, results: this.checkFrom.results }).then(res => {
        if (res.data.success) {
          this.$message.success('处理成功')
          this.checkDialog = false
          this.onSubmit()
        }
      })
    },
    addType (name) {
      if (name === '') {
        this.$message.error('请输入投诉类型')
        return
      }
      addComplaintsType({ name }).then(res => {
        if (res.data.success) {
          this.$message.success('添加成功')
          this.getComplaintsTypeList()
        }
      })
    },
    deleteType (scope) {
      deleteComplaintsType(scope.row.id).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.getComplaintsTypeList()
        }
      })
    },
    getComplaintsTypeList () {
      getComplaintsTypeList().then(res => {
        if (res.data.success) {
          this.typeList = res.data.data
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    getComplain (val) {
      complaintsGetComplaintsList({ pageNum: val.pageNum, pageSize: val.pageSize, complaintsVo: this.formInline }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data.records
          this.queryInfo.total = res.data.data.total
          this.tableData.forEach((item) => {
            if (item.handleStatus === 'PENDING') {
              item.handleStatus = '待处理'
            }
            if (item.handleStatus === 'HANDLE') {
              item.handleStatus = '已处理'
            }
            if (item.handleStatus === 'REFUSE') {
              item.handleStatus = '已拒绝'
            }
          })
        } else {
        }
      })
    },
    onSubmit () {
      this.getComplain(this.queryInfo)
    },
    getOrderStatus (row) {
      if (row.handleStatus === '待处理') {
        // this.$refs.dialogRef.show('complain', '投诉详情', val.id)
        complaintGetById(row.id).then(res => {
          if (res.data.success) {
            this.checkFrom = { results: '', ...res.data.data }
            this.checkDialog = true
          }
        })
      }
    },
    asd () {
      this.getComplain(this.queryInfo)
    },
    setComplain (val) {
      this.tableData[val.index].complainCn = val.mes
      this.tableData[val.index].handleStatus.flag = true
      this.tableData[val.index].handleStatus.name = '已处理'
    },
    changePage (val) {
      this.queryInfo = val
      this.getComplain(this.queryInfo)
    },
    changeDate (val) {
      if (val) {
        this.formInline.createTimeBegin = val[0]
        this.formInline.createTimeEnd = val[1]
      } else {
        this.formInline.createTimeBegin = ''
        this.formInline.createTimeEnd = ''
      }
    }
  }
}
</script>
 <style scoped lang="less">
 @import "index";
 @deep: ~">>>";
 
 @{deep} .el-textarea.is-disabled .el-textarea__inner {
   color: #000;
   background: #fff;
 }
 </style>
